export default {
  heading: "變更密碼",
  currentPassword: "現有密碼",
  newPassword: "新密碼",
  confirmNewPassword: "再次確認新密碼",
  passwordStrength: "密碼強度：",
  lengthInfo: "密碼必須包含至少{minlength}個字元",
  complexText: {
    1: "可使用大寫與小寫字母、數字或符號",
    2: "以及下列任何兩項：大寫字母、小寫字母、數字或符號",
    3: "以及下列任何三項：大寫字母、小寫字母、數字或符號",
    4: "以及下列四項：大寫字母、小寫字母、數字和符號"
  },
  strength: {
    0: "很弱",
    1: "弱",
    2: "中",
    3: "強",
    4: "很强"
  },
  currentPasswordIsEmpty: "請輸入現有密碼。",
  currentPasswordIsWrong: "您所輸入的現有密碼不正確。",
  newPasswordIsEmpty: "請輸入新密碼。",
  newPasswordIsNotSecurity: "您所輸入的新密碼未達安全要求，請重新輸入。",
  newPasswordIsSameAsOld: "新密碼與舊密碼相同，請重新輸入。",
  confirmNewPasswordIsEmpty: "請再次確認新密碼。",
  confirmNewPasswordIsNotSame: "您所輸入的密碼不符，請重新輸入。",
  confirmDialogContent: "確定新密碼？",
  confirmUpdate: "確定",
  cancelUpdate: "取消",
  closeBtn: "關閉",
};
